/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquarePlus: {
  name: 'square-plus';
  data: string;
} = {
  name: 'square-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="1" width="14" height="14" rx="1"/><path d="M5 8h6M8 5v6"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
